import { render, staticRenderFns } from "./PitanjeSingle.vue?vue&type=template&id=94725a6e&scoped=true&"
import script from "./PitanjeSingle.vue?vue&type=script&lang=js&"
export * from "./PitanjeSingle.vue?vue&type=script&lang=js&"
import style0 from "./PitanjeSingle.vue?vue&type=style&index=0&id=94725a6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94725a6e",
  null
  
)

export default component.exports